/**
 * Created by calhosh on 10/14/2024
 */

import styled from 'styled-components';
import Toast from './Toast';

const StyledMotifToast = styled(Toast)``;

export default StyledMotifToast;
